import { Globe } from "lucide-react";

import { AgentLanguageInput } from "@/generated";
import { LanguageOption } from "@/types/api/spotflow/spotflow-config";
import { cn } from "@/lib/utils";

export type LanguageDescriptor = { label: string; tag?: string };

export const describeLanguage = (
  language: AgentLanguageInput,
  optionByValue: Map<string, LanguageOption>
): LanguageDescriptor => {
  const option = optionByValue.get(language.code);
  return { label: option?.label ?? language.code, tag: option?.tag };
};

export const getIntroText = (language: AgentLanguageInput | undefined) =>
  language?.introductory_message?.[0]?.text ?? "";

export const LanguageChip = ({
  tag,
  className,
}: {
  tag?: string;
  className?: string;
}) => {
  const base =
    "flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-accent text-muted-foreground";
  if (tag) {
    return (
      <div className={cn(base, "text-[10px] font-medium uppercase", className)}>
        {tag}
      </div>
    );
  }
  return (
    <div className={cn(base, className)}>
      <Globe className="h-3.5 w-3.5" />
    </div>
  );
};
